import { render, staticRenderFns } from "./selectionTable.vue?vue&type=template&id=139ee41e&"
import script from "./selectionTable.vue?vue&type=script&lang=ts&"
export * from "./selectionTable.vue?vue&type=script&lang=ts&"
import style0 from "./selectionTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports